// extracted by mini-css-extract-plugin
export default {"addButton":"app-portainer-components-Button-AddButton-module__add-button"};